<template>
  <div class="p-3 bg-white card border-radius-xl mt-3 me-3" data-animation="FadeIn">
    <div class="mt-3 row">
      <div class="form-group col-12 col-md-4 mt-sm-0">
        <label class="required">{{ $t('trainingPlanType') }}</label>
        <select
          class="form-control custom-select"
          name="plan_group"
          required
          id="select-plan_group"
          v-model="state.plan_group"
          @change="selecionaTipoPlano"
        >
          <option value="">{{ $t('selectOption') }}</option>
          <option value="0">{{ $t('individualTrainingPlan') }}</option>
          <option value="1">{{ $t('groupTrainingPlan') }}</option>
        </select>
      </div>
    </div>
    <div class="row" v-if="state.plan_group == '1'">
      <div class="col-12">
        <h5>{{ $t('createNewGroupOrLink') }}</h5>
      </div>
      <div class="col-12 form-group d-flex">
        <div class="form-check me-3" @click="state.novoPlanoGrupo = '1'">
          <input
            class="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault1"
            :checked="state.novoPlanoGrupo == '1'"
          />
          <label class="form-check-label" for="flexRadioDefault1">
            {{ $t('createNewGroupTraining') }}
          </label>
        </div>
        <div class="form-check" @click="state.novoPlanoGrupo = '0'">
          <input
            class="form-check-input"
            type="radio"
            name="flexRadioDefault"
            :checked="state.novoPlanoGrupo == '0'"
          />
          <label class="form-check-label" for="flexRadioDefault2">
            {{ $t('linkToExistingGroup') }}
          </label>
        </div>
      </div>
    </div>
    <div class="row" v-if="state.plan_group == '1' && state.novoPlanoGrupo == '0'">
      <div class="form-group col-12 col-md-4 mt-sm-0">
        <label class="required">{{ $t('selectGroupToLink') }}</label>
        <select
          class="form-control custom-select"
          name="include-plan_group"
          required
          id="select-include-plan_group"
          v-model="state.includePlan"
          @change="vinculaAlunoPlano"
        >
          <option value="">{{ $t('selectOption') }}</option>
          <option v-for="(item, index) in state.planos" :key="index" :value="index">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>

    <!-- INICIO CADASTRO -->
    <div
      v-if="
        state.plan_group == '0' ||
        (state.plan_group == '1' && state.novoPlanoGrupo == '1') ||
        (state.plan_group == '1' && state.novoPlanoGrupo == '0' && parseInt(state.plano.id) > 0)
      "
    >
      <div class="row">
        <div class="form-group col-12 col-md-4">
          <label for="" class="required">{{ $t('trainingPlanName') }}</label>
          <input class="form-control" type="text" v-model="state.plano.name" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12 col-md-4">
          <label class="required">{{ $t('macrociclo') }}</label>
          <select
            class="form-control custom-select"
            name="cycle"
            required
            id="select-cycle"
            v-model="state.plano.training_cycle_id"
          >
            <option value="">{{ $t('selectMacrociclo') }}</option>
            <option v-for="(item, index) in state.ciclos" :key="index" :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="form-group col-12 col-md-8">
          <label class="required">{{ $t('goal') }}</label>
          <input
            class="form-control"
            type="text"
            :placeholder="$t('goalPlaceholder')"
            v-model="state.plano.objective"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12 col-md-4">
          <label>{{ $t('startDate') }}</label>
          <input
            class="form-control"
            type="text"
            v-maska="'##/##/####'"
            :placeholder="$t('startDate')"
            v-model="state.plano.initial_date"
          />
        </div>
        <div class="form-group col-12 col-md-4">
          <label>{{ $t('endDate') }}</label>
          <input
            class="form-control"
            type="text"
            v-maska="'##/##/####'"
            :placeholder="$t('endDate')"
            v-model="state.plano.final_date"
          />
        </div>
        <div class="form-group col-12 col-md-4 align-self-end font-weight-bold">
          {{ dayAndWeek }}
        </div>
      </div>
      <!--      <div class="row mb-3">
        <div class="col-12">
          <label for="">Dias de treino</label>
        </div>
        <div class="col-12 text-sm">
          <div class="row ms-auto">
            <div class="col form-check pointer" @click="state.plano.monday = !state.plano.monday">
              <input
                class="mt-1 form-check-input"
                type="checkbox"
                value="1"
                v-model="state.plano.monday"
              />
              <span class="ms-1">Segunda-feira</span> 
            </div>
            <div class="col form-check pointer" @click="state.plano.tuesday = !state.plano.tuesday">
              <input
                class="mt-1 form-check-input"
                type="checkbox"
                
                v-model="state.plano.tuesday"
              />
              <span class="ms-1">Terça-feira</span>
            </div>
            <div class="col form-check pointer" @click="state.plano.wednesday = !state.plano.wednesday">
              <input
                class="mt-1 form-check-input"
                type="checkbox"
                
                v-model="state.plano.wednesday"
              />
              <span class="ms-1">Quarta-feira</span>
            </div>
            <div class="col form-check pointer" @click="state.plano.thursday = !state.plano.thursday">
              <input
                class="mt-1 form-check-input"
                type="checkbox"
                value="1"
                v-model="state.plano.thursday"
              />
              <span class="ms-1">Quinta-feira</span>
            </div>
            <div class="col form-check pointer" @click="state.plano.friday = !state.plano.friday">
              <input
                class="mt-1 form-check-input"
                type="checkbox"
                value="1"
                v-model="state.plano.friday"
              />
              <span class="ms-1">Sexta-feira</span>
            </div>
            <div class="col form-check pointer" @click="state.plano.saturday = !state.plano.saturday">
              <input
                class="mt-1 form-check-input"
                type="checkbox"
                value="1"
                v-model="state.plano.saturday"
              />
              <span class="ms-1">Sábado</span>
            </div>
            <div class="col form-check pointer" @click="state.plano.sunday = !state.plano.sunday">
              <input
                class="mt-1 form-check-input"
                type="checkbox"
                value="1"
                v-model="state.plano.sunday"
              />
              <span class="ms-1">Domingo</span>
            </div>
          </div>
        </div>
      </div>-->
      <div class="row mb-3">
        <div class="col-12 d-flex">
          <label for="">{{ $t('trainingDaysOrGroups') }}</label>
          <button
            type="button"
            class="ms-3 btn btn-sm font-weight-normal btn-outline-info p-1"
            style="font-size: 0.7rem"
            @click="addGrupo()"
          >
            {{ $t('newGroup') }}
          </button>
        </div>
        <div class="col-12 d-flex">
          <div v-for="(item, index) in state.plano.groups" :key="index" class="form-group me-2">
            <div class="input-group">
              <input
                type="text"
                class="form-control form-control-sm"
                :placeholder="$t('groupNamePlaceholder')"
                required
                v-model="item.name"
              />
              <span class="input-group-text text-body">
                <i class="fas fa-trash" aria-hidden="true" @click="removeGrupo(index)"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12 col-md-4">
          <label for="">{{ $t('notes') }}</label>
          <textarea class="form-control" rows="5" v-model="state.plano.observation"></textarea>
        </div>
      </div>
      <div class="row" v-if="state.plan_group == '1'">
        <div class="col-12">
          <label class="font-weight-bold text-sm">
            {{ $t('includeOtherStudents') }}
          </label>
        </div>
        <div class="col-12 col-md-4">
          <select2
            :ClearAfterSelectedProp="true"
            :ItemsProp="state.alunos"
            :FieldProp="'name'"
            :PlaceholderTextProp="$t('searchStudent')"
            @selected="alunoSelected"
          >
          </select2>
          <template v-for="(item, index) in state.alunosPlano" :key="index">
            <span>{{ item.name }}</span>
            <span
              class="pointer"
              data-bs-toggle="tooltip"
              data-bs-original-title="{{ $t('deleteStudent') }}"
              :title="$t('deleteStudent')"
              data-bs-placement="top"
              v-tooltip
              @click="removerAlunoPlano(index)"
            >
              <i class="text-danger fas fa-trash text-secondary mx-1"></i>
            </span>
          </template>
        </div>
      </div>
    </div>
    <!-- FIM NOVO PLANO DE TREINO -->

    <!-- PREVISÃO DE TREINOS COM CALENDÁRIOS -->
    <div
      v-if="showPrevisaoTreinos && trainingDays.length > 0"
      class="mt-4 border-top pt-4"
    >
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h5 class="text-primary mb-0">
          <i class="fas fa-calendar-alt me-2"></i>
          Previsão de Treinos
        </h5>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          @click="state.showCalendarios = !state.showCalendarios"
        >
          <i :class="state.showCalendarios ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          {{ state.showCalendarios ? 'Ocultar Calendários' : 'Visualizar Calendários' }}
        </button>
      </div>

      <!-- Período e Total -->
      <div class="mb-3">
        <p class="mb-1 text-muted">
          Período: {{ state.plano.initial_date }} a {{ state.plano.final_date }}
        </p>
        <p class="mb-0 font-weight-bold text-success" style="font-size: 1.1rem;">
          Total de Treinos Previstos: {{ totalTreinosPrevistos }}
        </p>
      </div>

      <!-- Resumo por Mês (Tabela) -->
      <div class="mb-4">
        <h6 class="font-weight-bold mb-2">Por mês:</h6>
        <div class="table-responsive" style="max-width: 400px;">
          <table class="table table-sm table-bordered mb-0">
            <tbody>
              <tr v-for="(mes, index) in resumoPorMes" :key="index">
                <td class="text-muted">{{ mes.nome }}:</td>
                <td class="text-end text-primary font-weight-bold">{{ mes.treinos }} treinos</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Calendários Visuais -->
      <div v-if="state.showCalendarios" class="calendarios-container">
        <div class="row">
          <div
            v-for="(mesData, index) in calendariosMeses"
            :key="index"
            class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
          >
            <div class="calendario-mes">
              <div class="calendario-header text-danger">
                {{ mesData.nome }}
              </div>
              <div class="calendario-dias-header">
                <span>D</span>
                <span>S</span>
                <span>T</span>
                <span>Q</span>
                <span>Q</span>
                <span>S</span>
                <span>S</span>
              </div>
              <div class="calendario-grid">
                <template v-for="(semana, sIndex) in mesData.semanas" :key="sIndex">
                  <span
                    v-for="(dia, dIndex) in semana"
                    :key="dIndex"
                    :class="{
                      'dia-vazio': dia.vazio,
                      'dia-previsto': dia.previsto,
                      'dia-executado': dia.executado,
                      'dia-fora-periodo': dia.foraPeriodo,
                      'dia-normal': !dia.vazio && !dia.previsto && !dia.executado && !dia.foraPeriodo
                    }"
                  >
                    {{ dia.numero || '' }}
                  </span>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- Legenda -->
        <div class="legenda-calendario mt-3">
          <span class="legenda-item">
            <span class="legenda-cor bg-previsto"></span>
            Previsto
          </span>
          <span class="legenda-item">
            <span class="legenda-cor bg-executado"></span>
            Executado
          </span>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12 text-end">
        <router-link to="/planos-de-treino">
          <button type="button" class="btn bg-gradient-secondary">{{ $t('back') }}</button>
        </router-link>
        <button type="button" class="ms-3 btn bg-gradient-primary" @click.prevent="salvar">
          {{ $t('save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import alunoRepository from '../../../../services/api/alunoRepository'
import ciclosRepository from '../../../../services/api/ciclosRepository'
import { reactive, onMounted, ref, inject, watch, computed } from 'vue'
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import moment from 'moment'
import Select2 from '../../../../components/Select2.vue'
import planosTreinoRepository from '../../../../services/api/planosTreinoRepository'
import { useI18n } from 'vue-i18n'

export default {
  components: {
    Select2,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()
    const { t } = useI18n()

    const state = reactive({
      cep: '',
      plan_group: '',
      plano: {
        id: 0,
        plan_group: '',
        training_cycle_id: '',
        initial_date: '',
        final_date: '',
        students: [],
        groups: [],
      },
      novoPlanoGrupo: '1',
      planoTreinoId: 0,
      includePlan: '',
      ciclos: [],
      alunos: [],
      alunosPlano: [],
      planos: [],
      treinoElaborado: [],
      showCalendarios: true,
      studentTrainingDays: [], // Dias de treino do aluno selecionado
    })

    // Buscar dias de treino do aluno
    const buscarDiasTreinoAluno = () => {
      const studentId = store.getters.StudentManager
      if (!studentId) return

      alunoRepository.AlunoGetById(studentId)
        .then(response => {
          if (response.data.success && response.data.data) {
            let days = response.data.data.training_days
            if (typeof days === 'string') {
              try {
                days = JSON.parse(days)
              } catch (e) {
                days = []
              }
            }
            state.studentTrainingDays = days || []
          }
        })
        .catch(error => {
          console.error('Erro ao buscar dias de treino do aluno:', error)
        })
    }

    const inputNumero = ref(null)

    const dayAndWeek = computed(() => {
      // Valida se as datas estão no formato correto (DD/MM/YYYY)
      const initialDate = state.plano.initial_date || ''
      const finalDate = state.plano.final_date || ''

      // Verifica se as datas têm o formato completo DD/MM/YYYY
      const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/
      if (!dateRegex.test(initialDate) || !dateRegex.test(finalDate)) {
        return ''
      }

      let date1 = moment(initialDate.split('/').reverse().join('-'))
      let date2 = moment(finalDate.split('/').reverse().join('-'))

      // Verifica se as datas são válidas
      if (!date1.isValid() || !date2.isValid()) {
        return ''
      }

      let numberWeeks = date2.diff(date1, 'weeks')
      let numberDays = date2.diff(date1, 'days')
      return `${numberWeeks} ${t('weeks')} - ${numberDays} ${t('daysNumber')}`
    })

    // Dias de treino do aluno (busca do Vuex ou do state)
    const trainingDays = computed(() => {
      return Array.isArray(state.studentTrainingDays) ? state.studentTrainingDays : []
    })

    // Mapeamento de dia da semana para número do moment (0 = domingo, 1 = segunda, etc)
    const dayMapping = {
      'dom': 0,
      'seg': 1,
      'ter': 2,
      'qua': 3,
      'qui': 4,
      'sex': 5,
      'sab': 6
    }

    // Função auxiliar para validar formato de data DD/MM/YYYY
    const isValidDateFormat = (dateStr) => {
      if (!dateStr) return false
      const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/
      return dateRegex.test(dateStr)
    }

    // Verifica se deve mostrar a previsão de treinos
    const showPrevisaoTreinos = computed(() => {
      if (!isValidDateFormat(state.plano.initial_date) || !isValidDateFormat(state.plano.final_date)) return false
      const inicio = moment(state.plano.initial_date.split('/').reverse().join('-'))
      const fim = moment(state.plano.final_date.split('/').reverse().join('-'))
      return inicio.isValid() && fim.isValid() && fim.isAfter(inicio)
    })

    // Calcula os dias previstos de treino
    const diasPrevistos = computed(() => {
      if (!showPrevisaoTreinos.value || !Array.isArray(trainingDays.value) || trainingDays.value.length === 0) return []

      const inicio = moment(state.plano.initial_date.split('/').reverse().join('-'))
      const fim = moment(state.plano.final_date.split('/').reverse().join('-'))
      const dias = []

      // Converter os dias de treino para números
      const diasDaSemana = trainingDays.value.map(d => dayMapping[d]).filter(d => d !== undefined)

      // Iterar por cada dia no período
      let current = inicio.clone()
      while (current.isSameOrBefore(fim)) {
        if (diasDaSemana.includes(current.day())) {
          dias.push(current.format('YYYY-MM-DD'))
        }
        current.add(1, 'day')
      }

      return dias
    })

    // Total de treinos previstos
    const totalTreinosPrevistos = computed(() => {
      return diasPrevistos.value.length
    })

    // Resumo por mês
    const resumoPorMes = computed(() => {
      if (diasPrevistos.value.length === 0) return []

      const mesesMap = {}
      const nomeMeses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]

      diasPrevistos.value.forEach(data => {
        const m = moment(data)
        const key = m.format('YYYY-MM')
        const nome = `${nomeMeses[m.month()]} De ${m.year()}`

        if (!mesesMap[key]) {
          mesesMap[key] = { nome, treinos: 0, ordem: key }
        }
        mesesMap[key].treinos++
      })

      return Object.values(mesesMap).sort((a, b) => a.ordem.localeCompare(b.ordem))
    })

    // Calendários para cada mês do período
    const calendariosMeses = computed(() => {
      if (!showPrevisaoTreinos.value) return []

      const inicio = moment(state.plano.initial_date.split('/').reverse().join('-'))
      const fim = moment(state.plano.final_date.split('/').reverse().join('-'))
      const nomeMeses = [
        'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
        'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
      ]

      const calendarios = []
      let current = inicio.clone().startOf('month')

      while (current.isSameOrBefore(fim, 'month')) {
        const ano = current.year()
        const mes = current.month()
        const primeiroDia = moment([ano, mes, 1])
        const ultimoDia = moment([ano, mes, 1]).endOf('month')
        const diasNoMes = ultimoDia.date()
        const diaDaSemanaInicio = primeiroDia.day()

        const semanas = []
        let semanaAtual = []

        // Adiciona dias vazios no início
        for (let i = 0; i < diaDaSemanaInicio; i++) {
          semanaAtual.push({ vazio: true })
        }

        // Adiciona os dias do mês
        for (let dia = 1; dia <= diasNoMes; dia++) {
          const dataAtual = moment([ano, mes, dia])
          const dataStr = dataAtual.format('YYYY-MM-DD')

          const dentroPeriodo = dataAtual.isSameOrAfter(inicio, 'day') && dataAtual.isSameOrBefore(fim, 'day')
          const previsto = diasPrevistos.value.includes(dataStr)

          semanaAtual.push({
            numero: dia,
            previsto: previsto && dentroPeriodo,
            executado: false, // TODO: integrar com dados de execução
            foraPeriodo: !dentroPeriodo,
            vazio: false
          })

          if (semanaAtual.length === 7) {
            semanas.push(semanaAtual)
            semanaAtual = []
          }
        }

        // Completa a última semana
        while (semanaAtual.length > 0 && semanaAtual.length < 7) {
          semanaAtual.push({ vazio: true })
        }
        if (semanaAtual.length > 0) {
          semanas.push(semanaAtual)
        }

        calendarios.push({
          nome: nomeMeses[mes],
          ano: ano,
          semanas: semanas
        })

        current.add(1, 'month')
      }

      return calendarios
    })

    const buscarDadosPlano = () => {
      planosTreinoRepository
        .PlanosTreinoGetById(state.planoTreinoId)
        .then((response) => {
          if (response.data.success) {
            state.plano = response.data.data
            state.plan_group = state.plano.plan_group
            state.plano.sunday = state.plano.sunday == '1'
            state.plano.monday = state.plano.monday == '1'
            state.plano.tuesday = state.plano.tuesday == '1'
            state.plano.wednesday = state.plano.wednesday == '1'
            state.plano.thursday = state.plano.thursday == '1'
            state.plano.friday = state.plano.friday == '1'
            state.plano.saturday = state.plano.saturday == '1'
            state.plano.initial_date = state.plano.initial_date.split('-').reverse().join('/')
            state.plano.final_date = state.plano.final_date.split('-').reverse().join('/')
            if (state.plano.students.length > 0) {
              state.alunosPlano = state.plano.students
            }
          }
        })
        .catch((error) => {
          swal({
            icon: 'error',
            title: t('errorFetchingContracts'),
            text: error.message,
          })
        })
    }

    const buscarAlunos = () => {
      try {
        store.commit('SET_SPLASH_SCREEN', true)
        alunoRepository
          .AlunoGet()
          .then((response) => {
            store.commit('SET_SPLASH_SCREEN', false)
            if (response.data.success) {
              state.alunos = response.data.data
            }
          })
          .catch((error) => {
            store.commit('SET_SPLASH_SCREEN', false)
            swal({
              icon: 'error',
              title: t('errorListStudents'),
              text: error.message,
            })
          })
      } catch {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const buscarMacrociclos = () => {
      ciclosRepository
        .MacroCiclosGet()
        .then((response) => {
          if (response.data.success) {
            state.ciclos = response.data.data
          }
        })
        .catch((error) => {
          swal({
            icon: 'error',
            title: t('errorFetchingContracts'),
            text: error.message,
          })
        })
    }

    const selecionaTipoPlano = () => {
      // buscar dados do plano e carregar os campos
    }

    function alunoSelected(aluno = null) {
      if (aluno != null) {
        let res = state.alunosPlano.find((x) => x.id == aluno.id)
        if (!res) {
          state.alunosPlano.push(aluno)
        }
      }
    }

    function removerAlunoPlano(indexLista) {
      let aluno = state.alunosPlano[indexLista]
      state.alunosPlano.splice(indexLista, 1)
      planosTreinoRepository.PlanoTreinoAlunoDelete(state.plano.id, aluno.id)
    }

    const vinculaAlunoPlano = () => {
      if (state.includePlan == '') return
      state.plano = state.planos[state.includePlan]
    }

    const addGrupo = () => {
      // Adiciona o novo grupo
      state.plano.groups.push({
        name: '',
      })

      // Força a reatividade do Vue
      state.plano = { ...state.plano }
    }

    const removeGrupo = (index) => {
      // Remove o grupo do array
      state.plano.groups.splice(index, 1)

      // Força a reatividade do Vue
      state.plano = { ...state.plano }
    }

    function salvar() {
      try {
        validate().then((isValid) => {
          if (!isValid) {
            swal({
              icon: 'error',
              title: t('error'),
              text: t('errorListTrainingPlans'),
            })
            return
          }
          let plano = Object.assign({}, state.plano)
          plano.initial_date =
            plano.initial_date != '' ? plano.initial_date.split('/').reverse().join('-') : null
          plano.final_date =
            plano.final_date != '' ? plano.final_date.split('/').reverse().join('-') : null
          plano.students = []
          if (state.plan_group !== '1') {
            plano.students.push(store.getters.StudentManager)
          } else {
            state.alunosPlano.forEach((item) => {
              plano.students.push(item.id)
            })
          }
          store.commit('SET_SPLASH_SCREEN', true)
          if (plano.id == 0) {
            planosTreinoRepository
              .PlanosTreinoPost(plano)
              .then((response) => {
                store.commit('SET_SPLASH_SCREEN', false)
                if (response.data.success) {
                  swal({
                    title: t('trainingPlan'),
                    text: t('contractCreatedSuccessfully'),
                    icon: 'success',
                    customClass: {
                      confirmButton: 'btn bg-gradient-success',
                    },
                    buttonsStyling: false,
                  }).then(() => {
                    router.back()
                    setTimeout(() => {
                      location.reload()
                    }, 100)
                  })
                }
              })
              .catch((error) => {
                store.commit('SET_SPLASH_SCREEN', false)
                swal({
                  icon: 'error',
                  title: t('errorSavingContract'),
                  text: error.message,
                })
              })
          } else {
            planosTreinoRepository
              .PlanosTreinoPut(plano.id, plano)
              .then((response) => {
                store.commit('SET_SPLASH_SCREEN', false)
                if (response.data.success) {
                  swal({
                    title: t('trainingPlan'),
                    text: t('contractUpdatedSuccessfully'),
                    icon: 'success',
                    customClass: {
                      confirmButton: 'btn bg-gradient-success',
                    },
                    buttonsStyling: false,
                  }).then(() => {
                    router.back()
                    setTimeout(() => {
                      location.reload()
                    }, 100)
                  })
                }
              })
              .catch((error) => {
                store.commit('SET_SPLASH_SCREEN', false)
                swal({
                  icon: 'error',
                  title: t('errorUpdatingContract'),
                  text: error.message,
                })
              })
          }
        })
      } catch {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const validate = async () => {
      const result = await v$.value.$validate()
      return result
    }

    const rulesMessages = {
      required: helpers.withMessage(t('gradeRequired'), required),
    }
    const rules = {
      plano: {
        name: { required: rulesMessages.required },
        training_cycle_id: { required: rulesMessages.required },
        objective: { required: rulesMessages.required },
      },
      plan_group: { required: rulesMessages.required },
    }

    const v$ = useVuelidate(rules, state)

    // Watch para reagir quando o aluno selecionado mudar
    const currentStudent = computed(() => store.getters.StudentManager)
    watch(currentStudent, (newVal, oldVal) => {
      if (oldVal && newVal && newVal !== oldVal) {
        // Aluno mudou - redirecionar para a lista de planos
        router.push('/planos-de-treino')
      }
    })

    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)
      buscarAlunos()
      buscarMacrociclos()
      buscarDiasTreinoAluno() // Buscar dias de treino do aluno
      if (route.params.id && parseInt(route.params.id) > 0) {
        state.planoTreinoId = parseInt(route.params.id)
        buscarDadosPlano()
      } else {
        let dataHoje = moment().format('DD/MM/yyyy')
        state.plano.initial_date = dataHoje
        state.plano.final_date = dataHoje
      }
    })

    return {
      removeGrupo,
      addGrupo,
      selecionaTipoPlano,
      state,
      inputNumero,
      salvar,
      v$,
      dayAndWeek,
      vinculaAlunoPlano,
      alunoSelected,
      removerAlunoPlano,
      // Novas variáveis para calendário
      showPrevisaoTreinos,
      trainingDays,
      totalTreinosPrevistos,
      resumoPorMes,
      calendariosMeses,
    }
  },
}
</script>

<style scoped>
/* Calendário de Previsão de Treinos */
.calendarios-container {
  background: #2d2d2d;
  border-radius: 8px;
  padding: 20px;
}

.calendario-mes {
  background: #3d3d3d;
  border-radius: 8px;
  padding: 10px;
}

.calendario-header {
  text-align: left;
  font-weight: 500;
  font-size: 0.9rem;
  margin-bottom: 10px;
  color: #ff6b6b;
}

.calendario-dias-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-size: 0.75rem;
  color: #888;
  margin-bottom: 5px;
}

.calendario-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  text-align: center;
  font-size: 0.8rem;
}

.calendario-grid span {
  padding: 4px 2px;
  border-radius: 4px;
  color: #ddd;
}

.dia-vazio {
  color: transparent !important;
}

.dia-normal {
  color: #888;
}

.dia-fora-periodo {
  color: #555 !important;
}

.dia-previsto {
  background: linear-gradient(135deg, #a855f7, #c084fc) !important;
  color: #fff !important;
  font-weight: bold;
}

.dia-executado {
  background: linear-gradient(135deg, #10b981, #34d399) !important;
  color: #fff !important;
  font-weight: bold;
}

/* Legenda */
.legenda-calendario {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.legenda-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ccc;
  font-size: 0.85rem;
}

.legenda-cor {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

.bg-previsto {
  background: linear-gradient(135deg, #a855f7, #c084fc);
}

.bg-executado {
  background: linear-gradient(135deg, #10b981, #34d399);
}
</style>
